const getBitByPosition = (n: number, bitPosition: number): 0 | 1 => {
  return ((n >> bitPosition) & 1) === 1 ? 1 : 0;
};

export default getBitByPosition;
